import { tokens } from "../theme/theme";

export const mockDataTeam = [
  {
    id: 1,
    summary: "Friendly Alias Request",
    customer: "jonsnow@gmail.com",
    priority: "Medium",
    created: "June 14, 2025",
  },
  {
    id: 2,
    summary: "News release going out soon",
    customer: "cerseilannister@gmail.com",
    priority: "Low",
    created: "June 14, 2025",
  },
  {
    id: 3,
    summary: "New page build request",
    customer: "jaimelannister@gmail.com",
    priority: "Medium",
    created: "June 14, 2025",
  },
  {
    id: 4,
    summary: "Press release going out today",
    customer: "anyastark@gmail.com",
    priority: "Low",
    created: "June 14, 2025",
  },
  {
    id: 5,
    summary: "Friendly Alias Request",
    customer: "daenerystargaryen@gmail.com",
    priority: "Medium",
    created: "June 14, 2025",
  },
  {
    id: 6,
    summary: "Page header is missing from page",
    customer: "evermelisandre@gmail.com",
    priority: "High",
    created: "June 14, 2025",
  },
  {
    id: 7,
    summary: "Help with image component selection",
    customer: "ferraraclifford@gmail.com",
    priority: "Medium",
    created: "June 14, 2025",
  },
  {
    id: 8,
    summary: "Please create a re-direct",
    customer: "rossinifrances@gmail.com",
    priority: "Medium",
    created: "June 14, 2025",
  },
  {
    id: 9,
    summary: "My page has vanished",
    customer: "harveyroxie@gmail.com",
    priority: "High",
    created: "June 14, 2025",
  },
];

export const mockTriageDays = [
  {
    id: 1,
    monday: "Keith",
    tuesday: "Derek",
    wednesday: "Jay",
    thursday: "Fred",
    friday: "Keith"
  },
];
